//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../PDM/PDM.SearchFilterTerm.js";
let d=[[],[[[],"GetExcludeToggle",{R_:{excludeToggle:''}},0,0],[["excludeToggle"],"SetExcludeToggle",{},1,0],[["nTargets","targets"],"GetTargets",{},0,0],[["targets"],"SetTargets",{},1,0],[["distance","unitType"],"GetDistance",{},0,0],[["distance","unitType"],"SetDistance",{},2,0]],[]];
SPLM.PDM.ProximitySearchFilterTerm = class extends SPLM.PDM.SearchFilterTerm{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.ProximitySearchFilterTerm";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;